import { Divider, Form } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaCreditCard } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { getCardTypes } from "../../apis/actions/donation.actions";
import {
  resetMoyasar,
  setDonationTypeId,
  setDonnerName,
  setGift,
  setMobile,
  setModel,
  setModelId,
} from "../../apis/slices/moyasarSlice";
import { AppDispatch, RootState } from "../../apis/store";
import appel from "../../assets/icons/apple.svg";
import mada from "../../assets/icons/mada.svg";
import mc from "../../assets/icons/mc.svg";
import qitaf from "../../assets/icons/qitaf.png";
import visa from "../../assets/icons/visa.svg";
import MoyasarForm from "../../components/Moyasar/MoyasarForm";
import { getKey } from "../../components/utils/utils";
import PrimaryButton from "../Buttons/PrimaryButton";
import Gift from "./Gift";
import Share from "./Share";
import { getSponsorDetails } from "../../apis/actions/sponsor.actions";

interface DonationCardProps extends React.HTMLAttributes<HTMLDivElement> {
  class?: string;
  variant?: "donation" | "payment";
  donationTypes?: any;
  donationAmounts: any;
  donationAmount?: any;
  selectedDonation?: any;
  counter?: any;
  selectedShare?: any;
  handleClick: (body: any) => void;
  remainingAmount?: any;
  share_ids?: any;
  project: any;
  requirePhoneNumber?: boolean;
  type?: "المشاريع" | "تفريج كرب" | "التبرع العام";
}

const DonationCard = ({
  share_ids,
  remainingAmount,
  donationAmount,
  selectedDonation,
  donationAmounts,
  donationTypes,
  counter,
  selectedShare,
  project,
  requirePhoneNumber = false,
  type,
  ...props
}: DonationCardProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const [form] = Form.useForm();

  //Body card Donation visibility state
  const [isVisible, setIsVisible] = useState<boolean>(
    props.variant === "payment" ? true : false
  );
  const otpId =  useSelector(
    (state: RootState) => state?.recipient?.OtpId
  );
  const [displayMoyasar, setDisplayMoyasar] = useState<boolean>(false);

  //header Donation Card state animation
  const [isHeaderExpanded, setIsHeaderExpanded] = useState<string>("");
  //
  const [isDonationGiftEnabled, setIsDonationGiftEnabled] = useState(false);
  const [totalAmount, setTotalAmount] = useState<number>(0);
  //input Amount value State
  const [inputValue, setInputValue] = useState(
    (donationAmount && donationAmount.toString()) ?? 0
  );
  const childRef = useRef<{ getActiveDonation?: () => void }>(null);

  //used for animation body toogle visibility
  const toggleBodyVisibility = () => {
    if (isVisible) {
      setIsHeaderExpanded("no");
      form.resetFields();

      setTimeout(() => {
        setIsVisible(false);
      }, 1000);
    } else {
      setIsVisible(true);
      setIsHeaderExpanded("yes");
    }
  };

  // This useEffect hook validates the 'inputValue' by comparing it with 'remainingAmount'.
  // If 'inputValue' (parsed as an integer) is greater than 'remainingAmount',
  // it sets 'inputValue' to 'remainingAmount' to prevent exceeding the allowed amount.
  // The hook runs whenever 'inputValue' changes.
  useEffect(() => {
    if (parseInt(inputValue) > remainingAmount!!) {
      setInputValue(remainingAmount!!.toString());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue]);

  useEffect(() => {
    if (Number(inputValue) !== 0) {
      form.setFieldsValue({ inputField: inputValue });
    }
  }, [inputValue, form, dispatch]);

  useEffect(() => {
    dispatch(getCardTypes());
    dispatch(getSponsorDetails({ sponsor_id: otpId }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  const updateModel = (modelId: any, model: number | "", phone: string) => {
    dispatch(setModelId(modelId));
    dispatch(setModel(model));
    dispatch(setMobile(phone));
  };

  const validateDonation = async () => {
    await form.validateFields().then(() => {
      if (childRef.current?.getActiveDonation) {
        dispatch(setDonationTypeId(childRef?.current?.getActiveDonation()));
      }
      if (isDonationGiftEnabled) {
        const json = {
          sender_name: form.getFieldValue("inputFieldName"),
          card_type_id: form.getFieldValue("card_id")?.value,
          name: form.getFieldValue("inputFieldDedicatedName"),
          mobile_number: form.getFieldValue("inputFieldPhone"),
          send_copy_to_sender: form.getFieldValue("sendCopie") ?? false,
          show_name_in_dedication: form.getFieldValue("showName") ?? false,
          show_amount: form.getFieldValue("show_amount") ?? false,
          send_gift: true,
        };
        dispatch(setGift(json));
      }
      dispatch(setDonnerName(form.getFieldValue("inputFieldDonnerName") || ""));

      //props.handleClick();
      setDisplayMoyasar(true);
      if (project) {
        if (type === "المشاريع") {
          updateModel(
            project?.id,
            getKey("project"),
            form.getFieldValue("inputFieldPhoneNumber")
          );
        } else if (type === "تفريج كرب") {
          //korba
          updateModel(
            project?.id,
            getKey(project?.model),
            form.getFieldValue("inputFieldPhoneNumber")
          );
        } else if (type === "التبرع العام") {
          updateModel(
            project?.id,
            getKey("generalDonation"),
            form.getFieldValue("inputFieldPhoneNumber")
          );
        } else {
          updateModel(
            project?.id,
            getKey("project"),
            form.getFieldValue("inputFieldPhoneNumber")
          );
        }
      } else {
        updateModel(false, "", form.getFieldValue("inputFieldPhoneNumber"));
      }
    })
    // validation errors are shown under the fields by antd
    .catch(() => {});
  };

  return (
    <div className={`takaful--donation ${props.class}`}>
      <div
        {...props}
        className={`takaful--donation-card ${
          props.variant === "donation"
            ? "takaful--card-donation-size"
            : "takaful--card-payment-size"
        } ${props.className ?? ""}`}
      >
        {props.variant === "donation" && (
          <div
            className={`takaful--donation-card-header ${
              isHeaderExpanded === "yes"
                ? "expanded"
                : isHeaderExpanded === "no"
                ? "collapsed"
                : ""
            }`}
            onClick={() => toggleBodyVisibility()}
          >
            <p>{t("donation.title")}</p>
            <FaCreditCard className="takaful--fa-icon" />
          </div>
        )}
        {isVisible && (
          <div
            className={
              props.variant === "donation"
                ? `takaful--donation-card-body ${
                    isHeaderExpanded === "yes" ? "expanded" : "collapsed"
                  }`
                : "takaful--payment-card"
            }
          >
            <div className="takaful--donation-payment">
              <img className={`takaful--icon-btn`} src={mada} alt="" />
              <img className={`takaful--icon-btn`} src={mc} alt="" />
              <img className={`takaful--icon-btn`} src={visa} alt="" />
              <img className={`takaful--icon-btn`} src={appel} alt="" />
              <img className={`takaful--icon-btn`} src={qitaf} alt="" />
            </div>
            <Divider className="takaful--donation-divider" />
            <Share
              remainingAmount={remainingAmount}
              project={project}
              container={props.variant ?? "payment"}
              donationAmount={donationAmount}
              counter={counter}
              selectedShare={selectedShare}
              selectedDonation={selectedDonation}
              share_ids={share_ids}
              donation_type_ids={donationTypes ?? []}
              type={props.variant === "donation" ? "تفريج كرب" : type ?? "تفريج كرب"}
              isCompleted={false}
              setDonationAmount={(v) => setInputValue(v)}
              setTotalAmount={(v) => setTotalAmount(v)}
              ref={childRef}
            />

            <Gift
              form={form}
              variant={props.variant}
              requirePhoneNumber={requirePhoneNumber}
              isDonationGiftEnabled={isDonationGiftEnabled}
              setIsDonationGiftEnabled={setIsDonationGiftEnabled}
            />
            <PrimaryButton
              className="takaful--donation-btn"
              title="ساهم الآن"
              onClick={() => validateDonation()}
              disabled={
                // eslint-disable-next-line eqeqeq
                totalAmount == 0 || isNaN(totalAmount) || totalAmount < 5
              }
            />
          </div>
        )}
      </div>
      <MoyasarForm
        amount={totalAmount}
        description="Takaful"
        open={displayMoyasar}
        handleClose={() => {
          setDisplayMoyasar(false);
          dispatch(resetMoyasar());
        }}
      />
    </div>
  );
};

export default DonationCard;
